var app = angular
    .module('sensores')
    .factory('sensoresService', ['$http', '$q', '__env', '$routeParams', function sensoresService($http, $q, __env, $routeParams) {
        var serviceUrl = __env.apiUrl;
        var sensoresUrl = 'sensores';

        function getSensores(idInfraestructura) {
            return $http.get(serviceUrl + sensoresUrl + '/' + idInfraestructura);
        }

        return {
            getSensores: getSensores
        }
    }]);